const lang = {
  challenge: {
    detail: {
      chall_detail_parti: "Partecipanti",
      chall_detail_reward: "Ricompense",
      chall_detail_reward_item: "Elementi",
      chall_detail_reward_badges: "Badge",
      chall_detail_reward_badge: "Distintivo",
      chall_detail_reward_point: "Punti",
      chall_detail_goal: "Obiettivo",
      chall_detail_dist: "Distanza",
      chall_detail_workout: "Allenamento",
      chall_detail_workout_detail: "Allenamenti idonei",
      chall_detail_intro: "Introduzione",
      chall_detail_rank: "Classifica",
      chall_detail_btn_join: "Unisciti",
      chall_detail_time: "Termina tra",
      chall_detail_time_days: "Giorni",
      chall_detail_status_my: "Il mio stato",
      chall_detail_status_team: "Stato del Team",
      chall_detail_status_rank: "Classifica",
      chall_detail_status_progress: "Progresso",
      chall_detail_status_duration: "Durata",
      chall_detail_status_dist: "Distanza",
      chall_detail_status_cal: "Calorie",
      common_steps_low: "passi",
      common_rep_count: "Conteggio Ripetizioni",
      chall_detail_status_day: "Giorni di Allenamento",
      chall_detail_status_best: "Miglior Risultato",
      chall_detail_status_contribution: "Il mio contributo",
      chall_detail_btn_try: "Riprova",
      chall_detail_btn_start: "Inizia Sfida",
      chall_detail_btn_continue: "Continua Sfida",
      chall_detail_btn_expired: "Sfida Scaduta",
      chall_detail_reward_item_claim: "Richiedi",
      chall_detail_reward_badge_display: "Visualizza",
      chall_detail_toast_unstart: "Sfida non iniziata",
      chall_detail_toast_end: "Sfida terminata",
      chall_detail_rank_empty:
        "Nessun dato di classifica, inizia la tua sfida e aggiorna la classifica.",
      chall_detail_workout_collection_mt: "Collezione Specifica",
      chall_detail_workout_route: "Info Percorso",
      chall_detail_reward_mt: "Tutti i premi",
      chall_detail_workout_outrun: "Corsa all'aperto",
      chall_detail_workout_outcycle: "Ciclismo all'aperto",
      chall_detail_workout_outwalk: "Camminata all'aperto",
      chall_detail_workout_yoga: "Corso di Yoga",
      chall_detail_workout_cardio: "Corso Cardio",
      chall_detail_workout_strength: "Corso di Forza",
      chall_detail_workout_stretch: "Corso di Stretching",
      chall_detail_workout_run: "Tapis roulant",
      chall_detail_workout_cycle: "Ciclismo",
      chall_detail_workout_row: "Vogatore",
      chall_detail_workout_ellipt: "Ellittica",
      chall_detail_workout_step: "Stepper",
      chall_detail_workout_rnr: "Row-N-Ride",
      chall_detail_workout_minibike: "Mini Bike",
      chall_detail_workout_ski: "Scivolatore",
      chall_detail_workout_jump: "Salta la corda",
      chall_detail_workout_vibration_treadmill: "Tapis Roulant Vibrante",
      chall_detail_product_recommend: "Suggerimento di prodotto",
      chall_detail_version_update_note: "Questa versione non supporta questa funzione. Aggiorna per favore.",
      chall_detail_workout_stair: 'Scala',
      chall_detail_workout_slider: 'Arrampicata',

      chall_detail_workout_runcour: "Corsi di Corsa",
      chall_detail_workout_cyclecour: "Corsi di Ciclismo",
      chall_detail_workout_elliptcour: "Corsi Ellittici",
      chall_detail_workout_rowcour: "Corsi di canottaggio",
      chall_detail_workout_stepcour: "Corsi di Stepper",
      chall_detail_workout_prenatal: "Corsi Prenatali",
      chall_detail_workout_postpartum: "Corsi Postpartum",
      chall_detail_workout_meditation: "Corsi di Meditazione",
      chall_detail_workout_rnrcourses: "Corsi Row-N-Ride",
      chall_detail_workout_audio: "Corsi Audio",
      chall_detail_workout_pilates: "Pilates",
      chall_detail_workout_climber: "Corso di Arrampicata",


      chall_detail_workout_all: "Tutti gli allenamenti tracciati dall'app Sunnyfit.",
      chall_detail_workout_collection:
        "Allenati con i corsi di questa raccolta",
      chall_detail_goal_intro:
        "Allenati per %s giorni, %s %s ogni giorno.",
      chall_detail_team_join_mt: "Unisciti a un Team",
      chall_detail_team_create: "Crea Squadra",
      chall_detail_team_join_conf: "Unisciti al team",
      chall_detail_team_create_cxl: "Annulla",
      chall_detail_team_create_conf: "Salva",
      chall_detail_team_user_follow: "Segui",
      chall_detail_team_user_assign: "Assegna come Capitano",
      chall_detail_team_user_remove: "Rimuovi dal team",
      chall_detail_team_leave: "Lascia il team",
      chall_detail_team_user_following: "Segui",
      chall_detail_team_leave_note: "Sei sicuro di voler lasciare questo team?",
      chall_detail_team_leave_cxl: "Annulla",
      chall_detail_team_leave_conf: "Conferma",
      chall_detail_team_me: "Io",
      chall_detail_team_leave_toast:
        "Assegna il ruolo di capitano a uno dei tuoi compagni.",
      chall_detail_team_join_toast: "Seleziona una squadra",
      chall_detail_team_join_toast_full:
        "Il team selezionato è pieno. Seleziona un altro team o crea un nuovo team.",
      chall_detail_team_create_toast: "Inserisci il nome della tua squadra.",
      chall_detail_result_descrip_goal_com_1: "Complimenti!",
      chall_detail_result_descrip_goal_com_single: `I tuoi sforzi hanno dato i loro frutti. Continuiamo così!`,
      chall_detail_result_descrip_goal_com_team: `Il duro lavoro del tuo team ha dato i suoi frutti. Continuiamo così!`,
      chall_detail_result_descrip_goal_incom_1: "Continua così! 💪",
      chall_detail_result_descrip_goal_incom_2: `Respira, resetta e affrontiamo il prossimo insieme!`,
      chall_detail_result_descrip_other1_1: `Wow, sei al top!`,
      chall_detail_result_descrip_other1_single:
        "La tua dedizione ha dato i suoi frutti. Continua a guidare e ispirare gli altri!",
      chall_detail_result_descrip_other1_team: `La dedizione del tuo team ha dato i suoi frutti. Continua a guidare e ispirare gli altri!`,
      chall_detail_result_descrip_other2_1: "Bel lavoro! 💪",
      chall_detail_result_descrip_other2_single: `Sei al %s posto! Continua così!`,
      chall_detail_result_descrip_other2_team: `Your team is {rank} place! Way to go!`,
      chall_detail_result_descrip_other3_single: "Sei al %s posto!",
      chall_detail_result_descrip_other3_team: "La tua squadra è al %s posto!",
      chall_detail_result_descrip_other3_2: `Continua così, puntiamo a un rango ancora più alto la prossima volta!`,
      chall_detail_result_reward: `Ricompense Ricevute`,
      chall_detail_result_done: `Fatto`,
      chall_detail_result_share: `Condividi`,
      chall_detail_result_reward_badge: `Badge`,
      chall_detail_result_reward_point: `Punti`,
      chall_detail_result_reward_item: `Elementi`,
      chall_detail_workout_collection_time: "Tempo Stimato",
      chall_detail_start_workout: "Inizia un Allenamento",
      badge_detail_display: `Visualizza nel profilo`,
      badge_detail_remove: `Rimuovi dal profilo`,
      badge_detail_display_toast: `Ora Visualizzato nel Tuo Profilo`,
      badge_detail_remove_toast: `Rimosso dal Profilo`,
      invite_from: `Invita da:`,
      invite_from_friend: `Amici`,
      invite_from_contact: `Contatti`,
      invite_from_more: `Altro`,
      address_edit_mt: "Indirizzo di Spedizione",
      address_edit_note: "Tutti i dati saranno crittografati",
      address_edit_country: "Paese / Regione",
      address_edit_name: "Nome",
      address_edit_street: "Indirizzo",
      address_edit_apt: "Appartamento/Suite/Altro (Opzionale)",
      address_edit_city: "Città",
      address_edit_state: "Stato",
      address_edit_code: "CAP",
      address_edit_phone: "Numero di telefono",
      address_edit_btn: "Invia",
      address_edit_state_select_mt: "Seleziona Stato",
      address_edit_check: "Verifica indirizzo",
      address_edit_check_note:
        "Verifica l'indirizzo per garantire la consegna. I premi persi non saranno sostituiti.",
      address_edit_check_cxl: "Annulla",
      address_info_mt: "Indirizzo di Spedizione",
      address_info_name: "Nome",
      address_info_phone: "Telefono",
      address_info_address: "Indirizzo",
      common_courses_count: "Corsi",
      challenge_exchange_title1: 'Vuoi dedicare',
      challenge_exchange_title2: '%s punti per unirti?',
      challenge_exchange_mypt: 'Punti: %s',
      challenge_exchange_button1: '%s Punti Unisciti',
      challenge_exchange_button2: 'Guadagna più punti',
      challenge_exchange_button3: 'Annulla',
      challenge_exchange_toast: 'Iscrizione riuscita',

      chall_detail_workout_select_route: 'Seleziona Percorso',
      chall_detail_workout_route_select: 'Seleziona questo percorso',
      chall_detail_workout_change_route: 'Change',
      chall_detail_workout_my_route: 'Il mio percorso',
      chall_detail_status_scoring_rules: 'Regole di punteggio',
      
      chall_scoring_rules_main_title: "Come fare punti 🏆",
      chall_scoring_rules_goal_title: "🏁 Obiettivo completato (s% pt)",
      chall_scoring_rules_goal_descrip: "Raggiungi la distanza target per assicurarti i punti di completamento.\nStato: Guadagnato immediatamente al raggiungimento della distanza.",
      chall_scoring_rules_speed_title: "⚡ Bonus velocità (max s% pt)",
      chall_scoring_rules_speed_descrip: "Più velocemente finisci, più alto sarà il tuo punteggio! Il bonus velocità viene calcolato nell'esatto momento in cui raggiungi la distanza target.\nSuggerimento: Tempo di arrivo inferiore = Posizione più alta.",
      chall_scoring_rules_bonus_title: "🎯 Bonus costanza (max s% pt)",
      chall_scoring_rules_bonus_descrip: "La costanza paga! Guadagna +1 punto extra ogni volta che ripeti questa sfida (fino a s% pt).",
      chall_scoring_rules_ranking_title: "🥇 Regole di classifica",
      chall_scoring_rules_ranking_descrip: "Punteggio totale: Il tuo punteggio finale = Obiettivo + Velocità + Bonus (massimo 100 pt).\nBlocco: I punteggi vengono bloccati nel momento in cui raggiungi l'obiettivo. Continuare a muoversi serve solo per il tracciamento dell'allenamento e non cambierà la tua posizione.\nSpareggio: In caso di parità di punteggio, vince il tempo di arrivo più veloce.",
      
      share_challenge_poster_bub: '🔥 Unisciti a me in questa Sfida! 🏆️',
      share_poster_sologn: 'Diventa Fit Gratis, Cresci con Sunny Fam👉️',
      share_poster_challenge_success: 'Sfida completata',

      common_block_pop_title: "Uso Limitato",
      chall_detail_join_limit_content: 'A causa del rilevamento del tuo comportamento anomalo di raccolta dati, per garantire l\'equità della comunità, le tue funzioni Sfida sono state limitate.',
      me_contact: 'Contattaci',
    },
  },
  workout: {
    collection: {
      detail: {
        workout_course_collection_detail_mt: "Raccolta",
        workout_wt_collection_detail_mt: "Collezione Giro del Mondo",
        workout_course_collection_detail_count: "Corsi",
        workout_course_collection_detail_limit: "Corso a Tempo Limitato",
      },
    },
  },
  support: {
    equipment: {
      detail: {
        equip_support_equip_main: "Attrezzatura di Supporto",
        equip_support_equip_enter_tips: "Inserisci il modello del tuo attrezzo:",
        equip_support_equip_enter_content: "Inserisci modello...",
        equip_support_equip_tips_main: "Suggerimenti",
        equip_support_equip_tips_content: "Se non conosci il modello del dispositivo, puoi controllare l'etichetta sul corpo, come mostrato nell'immagine sotto.",
        equip_support_equip_contact_us_btn: "Contattaci",
        equip_support_equip_view_courses_btn: "Visualizza Corsi",
        btn_common_ok: "OK",
        btn_common_search: "Cerca",
      },
    },
  },
  contact: {
    detail: {
      contact_us_mt: "Contattaci",
      contact_us_feedback: "Invia feedback",
      contact_us_note:
        "Invia il tuo feedback o problema e ti risponderemo entro 2 giorni lavorativi!",
      contact_us_issue_type: "Ho bisogno di aiuto con",
      contact_us_issue_type_input: "Seleziona problema",
      contact_us_name: "Nome completo",
      contact_us_name_input: "Digita il tuo nome completo qui",
      contact_us_equip: "Modello attrezzo (Opzionale)",
      contact_us_equip_input: "Inserisci il numero modello dell'attrezzatura.",
      contact_us_email: "Email",
      contact_us_email_input: "Digita qui la tua email",
      contact_us_describe: "Descrivi il problema",
      contact_us_describe_input: "Lascia il tuo messaggio qui",
      contact_us_image: "Allegato Immagine/Video",
      contact_us_contact_info: "Informazioni di contatto",
      btn_common_send: "Invia",
      btn_common_submit: "Invia",
      contact_us_issue_type_mt: "Tipo di problema",
      contact_us_issue_type_equip: "Problemi con l'attrezzatura",
      contact_us_issue_type_equip_note: "Problema contatore/Danneggiato/Parti mancanti",
      contact_us_issue_type_app: "Problemi dell'app",
      contact_us_issue_type_app_note: "Funzionalità/Esperienza Utente",
      contact_us_issue_type_suggest: "Suggerimenti",
      contact_us_issue_type_suggest_note: "Aggiungi corsi / Aggiungi funzionalità",
      contact_us_issue_type_equip_meter: "Problema contatore",
      contact_us_issue_type_equip_damage: "Parte(i) danneggiata/e o mancante/i",
      contact_us_issue_type_app_regist: "Registrazione/Iscriviti",
      contact_us_issue_type_app_connect: "Connessione Bluetooth",
      contact_us_issue_type_app_googlefit: "Google Fit",
      contact_us_issue_type_app_applehealth: "Apple Health",
      contact_us_issue_type_app_video: "Riproduzione Video/Audio",
      contact_us_issue_type_app_plan: "Piani e Corsi/Programmi Programmati",
      contact_us_issue_type_app_account: "Account e Profilo",
      contact_us_issue_type_app_update: "Aggiornamento versione",
      contact_us_issue_type_app_data: "Anomalie dati",
      contact_us_issue_type_app_other: "Altri Problemi dell'App",
      contact_us_issue_type_app_wifi: "Connessione Wi-Fi",
      contact_us_result_mt: "Grazie per il tuo feedback!",
      contact_us_result_st: "Ti risponderemo entro 2 giorni lavorativi.",
      btn_common_done: "Fatto",
      btn_common_next: "Avanti",

      btn_common_camera: "Fotocamera",
      btn_common_photo_album: "Scegli foto dall'album",
      btn_common_video_album: "Scegli video dall'album",
      btn_common_cancel: "Annulla",

      camera_note_main: "Autorizzazione Fotocamera",
      camera_note_content: "Abbiamo bisogno dell'accesso alla tua fotocamera per caricare contenuti.",
      photo_note_main: "Permesso Foto",
      photo_note_content:
        "Abbiamo bisogno di accedere alle tue foto per caricare contenuti.",

      photo_note_btn_open_settings: "Apri Impostazioni",
      uploading_note_main: "Caricamento del tuo feedback...",
      uploading_note_schedule: "{currentUploadIndex} di {totalUploadCount} file caricati",
      uploading_note_tips: "Il file video potrebbe richiedere più tempo",

      album_attach_upload_failed_toast: "Caricamento non riuscito. Riprova.",
      album_attach_image_toast: "Puoi allegare fino a {number} immagini",
      album_attach_image_length_toast: "Puoi selezionare immagini entro %s MB ciascuna {size} MB ciascuna",
      album_attach_video_toast: "Puoi allegare fino a {number} video",
      album_attach_video_length_toast1: "Bitte wählen Sie ein Video innerhalb von {number} Sekunden aus.",
      album_attach_video_size_toast: "Seleziona un video entro {number} MB.",
    },
  },
  workoverview: {
    detail: {
      common_steps: "Passi",
      common_steps_low: "passi",
      workout_result_mt: "Dati Allenamento",
      workout_result_cal_in: "Calorie bruciate",
      workout_result_hamburger: "Hamburger",
      workout_result_hamburger_note:
        "Un hamburger equivale a circa %s calorie",
      workout_result_data_time: "Tempo",
      workout_result_data_dis: "Distanza",
      workout_result_data_cal: "Calorie",
      workout_result_data_height: "Altezza",
      workout_result_data_floors: "Piani",
      workout_result_data_cal_note:
        "Le calorie bruciate mostrate sulla tua app si basano sulla tua altezza e peso, quindi potrebbero non coincidere con i dati del tuo attrezzo.",
      workout_result_data_floor_note: "Un piano è circa 2,5 metri.",
      workout_result_data_steps: "Passi",
      workout_result_data_stroke: "Colpi",
      workout_result_data_stride: "Conteggio Passi",
      workout_result_data_avg: "Media",
      workout_result_data_max: "Max",
      workout_result_data_hr: "FC",
      workout_result_data_hr_analysis: "Analisi della Frequenza Cardiaca",
      workout_result_data_hr_zone: "Zona %s",
      workout_result_data_speed: "Velocità",
      workout_result_data_pace: "Ritmo",
      workout_result_pace_fast: "Più veloce",
      workout_result_data_resist: "Resistenza",
      workout_result_data_cadence: "RPM",
      workout_result_data_spm: "SPM",
      workout_result_data_str: "Cadenza",
      workout_result_data_rep: "Conteggio Ripetizioni",
      workout_result_data_reps: "Ripetizioni",
      workout_result_evaluate: "Valuta",
      workout_result_post: "Pubblica il mio risultato",
      workout_result_share_video: "Condividi Video Fantastico",
      workout_result_wu: "Riscaldamento",
      workout_result_main: "Allenamento Principale",
      workout_result_cd: "Defaticamento",
      workout_result_treadmill: "Allenamento Tapis Roulant",
      workout_result_bike: "Corsa in Bici Indoor",
      workout_result_elliptical: "Allenamento Ellittico",
      workout_result_rnr: "Row-N-Ride",
      workout_result_rower: "Allenamento con il vogatore",
      workout_result_stepper: "Allenamento Stepper",
      workout_result_data_incline: "Inclinazione",
      workout_result_run: "Corsa all'aperto",
      workout_result_walk: "Camminata all'aperto",
      workout_result_cycling: "Outdoor Cycling",
      workout_result_result_workout: "Allenamenti",
      workout_result_chall_score: "Punteggio",
      workout_result_map_hide_note: "La mappa sarà nascosta quando condividi.",
      workout_result_on_equipment: "Su attrezzi",
      workout_result_off_equipment: "Senza attrezzi",
      btn_common_done: "Fatto",
      btn_common_share: "Condividi",
      btn_common_try_again: "Riprova",
      common_completed: "Completato",
      common_remaining: "Rimanente",
      share_common_open: "Apri",
      social_user_follow: "Segui",
      social_user_following: "Segui",
      share_common_join_us: "Unisciti a noi",
      workout_result_movement_tag: "Movimento",
      workout_result_movement_note: "Questo allenamento di movimenti personalizzato dal piano Al. Vuoi creare il tuo piano esclusivo?",
      btn_try_now: "Prova Ora",
      workout_result_share: 'Share My Result',
      workout_result_movement_feedback: "Feedback",
      workout_result_movement_feedback_mt: "I tuoi feedback ci aiutano a migliorare",
      workout_result_movement_feedback_tip: "Come ti senti riguardo a questo allenamento?",
      btn_common_submit: "Invia",
    },
  },
  midYearReport: {
    workoutData_burnCalories: "Total Calories Burned",
    workoutData_workoutTimes: "Total # of Workouts",
    workoutData_workoutDays: "Total Days With Workouts",
    workoutData_workoutDuration: "Total Workout Time",

    community_title: `Thank you for contributing to 
    and being part of the SunnyFit community!`,
    community_friendsRanking: "Ranking Among Friends",
    community_rankOpen: "Top ",
    community_rankEnd: " among friends",
    community_postShares: "Posts Shared",
    community_likesReceived: "Posts Liked",
    community_share_unit: "Posts",
    community_like_unit: "Likes",


    // favoriteWorkout_title: "Favorite Workout Type",
    favoriteWorkout_totalNumberOfWorkouts: " Workouts Completed",
    favoriteWorkout_equivalentToSeveralBurgers: "Calories Burned Equal To",
    favoriteWorkout_totalDistance_Metric: "Total distance in kilometers", //公制距离
    favoriteWorkout_totalDistance_Imperial: "Total distance in miles", //英制距离
    favoriteWorkout_MaxRPMAchieved: "Max RPM Achieved",
    favoriteWorkout_MaxSPMAchieved: "Max SPM Achieved",
    favoriteWorkout_TotalDuration: "Total duration",
    favoriteWorkout_TotalCaloriesBurned: "Calories Burned",
    favoriteWorkout_fastestPace: "Your fastest pace completed",
    favoriteWorkout_fastestCadence: "Your fastest cadence completed",
    // favoriteWorkout_fastReps: "Your fastest reps completed",
    // favoriteWorkout_fastStrokesRate: "Your fastest strokes rate completed",
    favoriteWorkout_maxStrokes: "Your max strokes completed",
    favoriteWorkout_maxFrequency: "Your max frequency completed",
    favoriteWorkout_totalDaysOfWorkout: "Total Days of &*& Workouts",

    favorite_favorite: "Favorite",
    favoriteTrainer_descTime: "Over the past six months, you took workout courses with &*& Sunny Trainers",
    favoriteTrainer_descTrain: "You completed &*& courses with your favorite trainer, &*& !",
    
    // favoriteCourses_accompanyYou: "accompany you",
    favoriteCourses_title: "New courses are added to SunnyFit every week!",
    favoriteCourses_coursesDesc: "That's equivalent to watching &*& movies!",

    noData_title: "SunnyFit Workout Report",
    noData_info: "Unfortunately, the workout data you provided for 2024 is insufficient. ",

    common_share: "Share",
    common_back: "Back",
    common_joinNow: "Join Now",
    common_update: "Please update to the latest version.",
  },
  pointsMall:{
    product:{
      detail: {
        "product_detail_top_title":"Dettagli prodotto",
        "product_detail_mypoints":"I miei punti:",
        "product_detail_exchange":"Scambia",
        "product_detail_earn":"Guadagna più punti",
        "product_detail_stock":"Non disponibile",
        "product_detail_null_title":"I dati sono anomali, riprova più tardi.",
        "product_detail_null_button":"Aggiorna",
        "product_detail_promotional1": "Termine Limitato %s",
        "product_detail_promotional2": "Limitato | Solo %s rimasti",
        "product_detail_promotional3": "Limitato | Esaurito",
        "product_detail_gift_others": "Gift for Others",
        "product_detail_gift_myself": "Gift for Myself"
      }
    },
    order:{
      detail: {
        "exchange_detail_my_order_title":"Il mio ordine",
        "exchange_detail_view_points":"I miei punti",
        "exchange_detail_discount": "Sconto",
        "exchange_detail_expected_deduction":"Detrazione Prevista",
        "exchange_detail_balance":"Equilibrio",
        "exchange_detail_out_of_stock":"Al momento questo articolo è esaurito. Ricontrolla presto.",
        "exchange_detail_redemption_toast":"Il riscatto supera il limite.",
        "exchange_detail_confirm_exchange":"Conferma Scambio",

        "exchange_successful_title":"Riscatto riuscito",
        "exchange_successful_goods_send_info":"I prodotti saranno spediti entro 3-5 giorni lavorativi!",
        "exchange_successful_check_order_detail":"Per avviare il processo di riscatto, controlla i dettagli dell'ordine.",
        "exchange_successful_back":"Indietro",
        "exchange_successful_view":"Visualizza Dettaglio Ordine",

        "orders_history_detail_address_title1":"Telefono",
        "orders_history_detail_address_title2":"Indirizzo",
        "orders_history_detail_address_title3":"Email",
        "orders_history_null_title": "Qui è vuoto",
        "address_detail_add_shipping_address":"Aggiungi indirizzo di spedizione",
        "address_detail_add":"Aggiungi",
        "address_detail_default":"Predefinito",
        "address_detail_set_as_default":"Imposta come predefinito",
        "address_detail_my_address":"Il mio indirizzo",
        "address_detail_delete":"Elimina",
        "address_detail_edit":"Modifica",
        "address_detail_add_a_shipping_address":"+ Aggiungi Indirizzo",
        "address_detail_delete_tips":"Elimina suggerimenti",
        "address_detail_toast":"Sei sicuro di eliminare questo indirizzo?",
        "address_detail_cancel":"Annulla",
        "address_detail_delete":"Elimina",

        "shipping_address_title":"Indirizzo di Spedizione",
        "shipping_address_data_encryption_info":"Tutti i dati saranno crittografati",
        "shipping_address_country_region":"Paese / Regione",
        "shipping_address_first_name":"Nome",
        "shipping_address_first_name_prompt":"Inserisci il nome",
        "shipping_address_last_name":"Cognome",
        "shipping_address_last_name_prompt":"Inserisci il cognome",
        "shipping_address_address_line_1":"Indirizzo Linea 1",
        "shipping_address_address_line_1_desc":"Nome via e numero civico, nome azienda",
        "shipping_address_address_line_2":"(Opzionale) Indirizzo Riga 2",
        "shipping_address_address_line_2_sub":"(Optional) ",
        "shipping_address_address_line_2_desc":"Edificio/Appartamento/Suite n., Unità, Piano, ecc.",
        "shipping_address_state":"Stato",
        "shipping_address_state_prompt":"Seleziona Stato",
        "shipping_address_city":"Città",
        "shipping_address_city_prompt":"Inserisci città",
        "shipping_address_zip_code":"CAP",
        "shipping_address_zip_code_prompt":"Inserisci CAP",
        "shipping_address_phone_number":"Numero di telefono",
        "shipping_address_phone_number_prompt":"Inserisci numero di telefono",
        "shipping_address_email_address":"Indirizzo email",
        "shipping_address_email_address_desc":"Per ricevere informazioni sulla spedizione",
        "shipping_address_security_privacy_info":"Sicurezza e Privacy",
        "shipping_address_security_privacy_desc":"Adottiamo misure fisiche, tecniche e amministrative standard del settore per proteggere le tue informazioni personali.",
        "shipping_address_save":"Salva",
        "shipping_address_name":"Inserisci il tuo Nome e Cognome con 2-32 caratteri.",
        "shipping_address_toast":"Ci scusiamo, ma il nostro programma di riscatto punti è attualmente disponibile solo per gli utenti nei 48 stati contigui degli Stati Uniti.",

      "orders_history_top_title":"Storico Ordini",
      "orders_history_list_view":"Visualizza Dettaglio",
      "orders_history_list_date":"Data di scambio:",
      "orders_history_null_button":"Scambio Punti",
      "orders_history_detail_top_title":"Dettaglio Ordine",
      "orders_history_detail_tracking_title":"Numero di tracciamento",
      "orders_history_detail_coupon_code":"Codice Coupon",
      "orders_history_detail_coupon_time":"Scadenza Coupon",
      "orders_history_detail_tracking_state":"Elaborazione",
      "ordershi_history_detail_date_title":"Data di Scambio",
      "orders_history_detail_spend_title":"Trascorri",
      "orders_history_detail_order_title":"Numero Ordine",
      "orders_history_detail_instructions":"Istruzioni",
      "orders_history_detail_copy":"Copia",
      "orders_history_detail_copy_toast":"Copia riuscita",
      "orders_history_tab_1":"Ordini di Scambio",
      "orders_history_tab_2":"Ordini Corsi",

      "invite_reward_order_type":"Premio di segnalazione",
      "event_reward_order_type":"Premio evento",

      "rewards_points_toast_error200": "Ordine creato con successo",
      "rewards_points_toast_error302": "Promozione non valida",
      "rewards_points_toast_error404": "I dati sono anomali, riprova più tardi.",
      "rewards_points_toast_error412": "I dati sono anomali, riprova più tardi.",
      "rewards_points_toast_error999": "I dati sono anomali, riprova più tardi.",
      "rewards_points_toast_error14001": "Articolo fuori produzione",
      "rewards_points_toast_error14002": "Al momento non disponibile. Ricontrolla presto.",
      "rewards_points_toast_error14003": "Punti insufficienti",
      "rewards_points_toast_error14004": "Limite superato",
      "rewards_points_toast_error14005": "Fuori dal periodo promozionale",
      "rewards_points_toast_error14006": "Riscatto promozione limitata esaurito",
      "rewards_points_toast_error14008": "The Gift has been claimed",
      "rewards_points_toast_error14010": "Past the claim validity period - Gift has been returned",
      }
    },
  },
  common: {
    common_no_content: "Nessun Contenuto",
    common_loading_failed: "Caricamento fallito",
    common_refresh: "Refresh",
    common_loading: "Caricamento...",
    common_points: "Punti",
    common_intensity_beg: "Principiante",
    common_intensity_int: "Intermedio",
    common_intensity_adv: "Avanzato",
    common_no_more_data: "Nessun altro dato",
    common_days: "Giorni",
  },
  workoutType: {
    Treadmill: "Treadmill",
    IndoorBike: "Indoor Bike",
    Elliptical: "Elliptical",
    Stepper: "Stepper",
    Rowing: "Rowing",
    RowNRide: "Row-N-Ride",
    Cardio: "Cardio",
    Yoga: "Yoga",
    Strength: "Strength",
    prenatal: "prenatal",
    postpartum: "postpartum",
    meditation: "meditation",
    Audio: "Audio",
    Stretching: "Stretching",
    outdoorRunning: "outdoor running",
    outdoorCycling: "outdoor cycling",
    outdoorWalking: "outdoor walking",
  }
};
export default lang;



// WEBPACK FOOTER //
// ./src/locales/it.js